import { useMemo } from 'react';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

type Result = ModelHookResult<{
	isShown: boolean;
	count: number;
}>;

export const useSupporterVoices = (): Result => {
	const {
		data: {
			supporterVoicesVideos: { totalCount: supporterVideosCount },
			petition: {
				commentsConnection: { totalCount: commentsCount },
			},
		},
	} = usePetitionDetailsPageData();

	const totalCount = Number(commentsCount) + Number(supporterVideosCount);

	return useMemo(() => {
		return {
			data: {
				isShown: totalCount >= 3,
				count: totalCount,
			},
		};
	}, [totalCount]);
};
